import { render, staticRenderFns } from "./Declaration_ddm.vue?vue&type=template&id=6963d75c&scoped=true"
import script from "./Declaration_ddm.vue?vue&type=script&lang=js"
export * from "./Declaration_ddm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963d75c",
  null
  
)

export default component.exports